import { en } from "./en";
import type { LandingCopy } from "./types";

export const ru: LandingCopy = {
  localeName: "Русский",
  nav: {
    games: "Игры",
    studio: "Студия",
    privacy: "Приватность",
    support: "Поддержка"
  },
  hero: {
    eyebrow: "Инди-студия игр",
    titleLineOne: "New",
    titleLineTwo: "Vision",
    titleLineThree: "Of Play",
    subtitle:
      "Мы даём классическим настольным идеям вторую жизнь:\nдобавляем глубину, новые решения и\nсовременный темп игры.",
    viewGames: "Смотреть игры",
    playNow: "Dice Triangles"
  },
  featured: {
    eyebrow: "Главная игра",
    title: "Dice Triangles",
    appStore: "App Store",
    googlePlay: "Google Play"
  },
  games: {
    eyebrow: "Наши игры",
    title: "Стратегические игры NVP",
    allGames: "Вся линейка",
    comingSoon: "Скоро",
    learnMore: "Подробнее"
  },
  details: {
    back: "NVP Games",
    howEyebrow: "Как играть",
    howTitle: "Бросок, линия, захват, очки",
    modesEyebrow: "Режимы",
    modesTitle: "Одни правила, несколько способов играть"
  },
  how: {
    eyebrow: "Как играть",
    title: "Простые правила. Большие решения.",
    steps: [
      {
        title: "Бросок",
        body: "Кубики задают пространство ходов, и каждый ход становится новой задачей."
      },
      {
        title: "Линия",
        body: "Соединяйте точки и готовьте ловушки для следующего захвата."
      },
      {
        title: "Захват",
        body: "Замыкайте треугольники, набирайте очки и забирайте территорию."
      }
    ]
  },
  online: {
    eyebrow: "Онлайн",
    title: "Комнаты, реванши, рейтинг",
    body:
      "Платформа строится вокруг лёгких multiplayer-циклов: быстрые комнаты, честные реванши, восстановимые сессии и понятный прогресс.",
    stats: [
      { value: "1v1", label: "Быстрые дуэли" },
      { value: "ELO", label: "Глобальный рейтинг" },
      { value: "CPU", label: "Тренировка офлайн" }
    ]
  },
  studio: {
    eyebrow: "Почему NVP Games",
    title: "Для игроков, которые любят думать быстро",
    body:
      "Мы любим игры, которые понятны с первого касания и раскрываются глубже на сотом матче.",
    values: [
      {
        title: "Умный геймплей",
        body: "Легко начать, сложно овладеть."
      },
      {
        title: "Реальные игроки",
        body: "Соревнуйтесь глобально в реальном времени."
      },
      {
        title: "Рейтинг",
        body: "Поднимайтесь выше и доказывайте мастерство."
      },
      {
        title: "Инди в сердце",
        body: "Фокус маленькой команды и решения в пользу игроков."
      }
    ]
  },
  cta: {
    title: "Готовы сыграть?",
    body:
      "Присоединяйтесь к первой волне игроков и помогите сформировать новое поколение стратегий NVP.",
    button: "Смотреть Dice Triangles"
  },
  footer: {
    tagline: "Современные стратегические игры для нового поколения.",
    rights: "Все права защищены.",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
      { label: "Support", href: "/support" }
    ]
  },
  legal: en.legal,
  support: {
    title: "Поддержка",
    body:
      "Напишите, что произошло, в какой игре, и укажите устройство или версию из стора, если знаете.",
    emailLabel: "Написать в поддержку"
  }
};
